module.exports = __webpack_public_path__ + "img/base_data1.deb5b764.png";